


































import {Component, Prop, Vue} from "vue-property-decorator";
import {IRangeIntRule} from "@/modules/Segmentation/models/SegmentationRules";

@Component
export default class RangeIntForm extends Vue {
    @Prop() public readonly value!: IRangeIntRule;
    @Prop() public readonly label?: string;
    @Prop() public readonly labelMeasure?: string;
    @Prop() public readonly errorMessages?: string[];

    change(e: string, key: "to" | "from"): void {
        if (this.errorMessages) {
            this.errorMessages.splice(0);
        }

        const value = parseFloat(e);

        if (isNaN(value)) {
            this.value[key] = null;
        } else {
            this.value[key] = value;
        }
    }
}
